import {useQuery} from '@tanstack/react-query'
import {parseResponseData} from '@/axiosInstance'
import {httpGetNotificationCount} from '../http/notifications.http'
import {QUERY_KEYS} from '@/queryClient'
import {NotificationCount} from '../types'

/**
 * Hook to fetch unread notification count
 */
export const useGetNotificationCount = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.NOTIFICATION_COUNT],
        queryFn: async () => {
            const {data} = await httpGetNotificationCount()
            return parseResponseData({
                responseData: data,
                responseShape: NotificationCount
            })
        }
        //refetchInterval: 30000, // Refetch every 30 seconds
    })
}
